import type React from 'react';
import {useOutletContext} from 'react-router';
import {Alert, Skeleton, Stack} from '@mui/material';
import {useSignalsActions, useSignalsQuery} from '../../hooks/useSignals';
import type {CategoryProfileOutletContext} from '../profileTypes';
import {ExternalRiskCard} from '../signals/ExternalRiskCard';
import {SignalSourceRegistry} from '../signals/SignalSourceRegistry';
import {SignalsFeed} from '../signals/SignalsFeed';
import {TaxonomyMappingCard} from '../signals/TaxonomyMappingCard';

/** External signals (spec 4.12): taxonomy mapping, external category risk, the signals feed and the source registry. */
export const ExternalSignalsTab: React.FC = () => {
    const {databagId, path, header} = useOutletContext<CategoryProfileOutletContext>();
    const {data, isLoading, isError} = useSignalsQuery(databagId, path);
    const actions = useSignalsActions(databagId, path);
    if (isError) return <Alert severity="error">Could not load the external signals.</Alert>;
    if (isLoading || !data) return <Stack gap={2}><Skeleton variant="rounded" height={90}/><Skeleton variant="rounded" height={260}/></Stack>;
    return (
        <Stack gap={3}>
            <TaxonomyMappingCard category={header.name} data={data}
                                 onConfirm={(node, code) => actions.confirmMapping(node, code, data.mapping)}/>
            <ExternalRiskCard risk={data.risk}/>
            <SignalsFeed data={data}/>
            <SignalSourceRegistry data={data}/>
        </Stack>
    );
};
